export default function renderDivider() {
  const divider = document.createElement('div');
  divider.classList.add('w5-value-percentage-cell__divider');
  return divider;
}